import Button from 'components/controls/buttons/button';
import FiltersIcon from 'assets/icons/filters.svg';
import type { MouseEventHandler } from 'react';
import styles from './filter-button.module.scss';

const FilterButton = ({ handleClick, mobileOnly }: IProps) => {
	return (
		<Button
			className={mobileOnly ? styles.mobileOnly : ''}
			data-testid={`toggle-show-filter-panel-${mobileOnly ? 'mobile' : 'desktop'}`}
			appearance="tertiary"
			onClick={handleClick}
		>
			Filters <FiltersIcon />
		</Button>
	);
};

export interface IProps {
	handleClick: MouseEventHandler;
	mobileOnly?: boolean;
}

export default FilterButton;
